import {createContext, PropsWithChildren, useContext, useEffect} from "react";
import {useDispatch} from "react-redux";
import type {Dispatch} from "redux";

import {useIsMobile} from "@pg-mono/hooks";

import {ISentLeadActions, setSentLeadValuesAction} from "../../../lead/reducers/sent_lead_reducer";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {useAppSelector} from "../../../store/hooks";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {IVendorDetailApplication} from "../../../vendor/types/IVendorDetailApplication";
import {IApplicationAnalyticsData} from "../../tracking/tracking";
import {ApplicationVariant} from "../../types/ApplicationVariant";
import {MessageType} from "../../types/MessageType";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/ApplicationSource";

interface IContextValue {
    // tracking
    analyticsData: IApplicationAnalyticsData;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    // form field visibility
    alwaysShowFields?: boolean;
    hideMessageAndQuestionsSection?: boolean;
    hideQuestions?: boolean;
    hideRooms?: boolean;
    // TODO: Remove this field from this context
    hideRodo?: boolean;
    hideSubmitButton?: boolean;

    // data
    property: IPropertyDetailApplication | null;
    offer: IOfferDetailApplication | null;
    offerId?: number;
    vendor: IVendorDetailApplication | null;

    // rest
    applicationMessageLogic: IApplicationMessageLogic;
    isAuthenticated?: boolean;
    isMobile: boolean;
    formPreviouslySent: boolean;
    onFormControlClick?: () => void;
    storeHash: string;
    onCloseModal: (forceClose?: boolean) => void;
    formDataInitialized?: boolean;
    isRequiredUserDataFilled?: boolean;
    emailNotificationProps: {
        isActive: boolean;
        onClose: () => void;
    };
    applicationVariant?: ApplicationVariant;

    //  post
    leadIsSubmitting: boolean;
    customFormText?: string;
    creditData?: {contribution: number; period: number};
}

type IApplicationFormProviderProps = PropsWithChildren<
    Omit<IContextValue, "property" | "offer" | "vendor" | "viewType" | "analyticsData" | "isMobile"> & {
        getAnalyticsData: () => IApplicationAnalyticsData;
    }
>;

export interface IApplicationMessageLogic {
    currentState: {
        messageType: MessageType;
        selectedQuestions: IApplicationAdditionalQuestionTypes[];
    };
    helpers: {
        setMessageType: (messageType: MessageType) => void;
        setSelectedQuestions: (questionsIds: IApplicationAdditionalQuestionTypes[]) => void;
    };
}

export type IApplicationAdditionalFlatQuestionTypes = "price" | "parkAndStorage" | "rent" | "payPlan" | "areaInfr" | "similarApts";

export type IApplicationAdditionalHouseQuestionTypes = "price" | "payPlan" | "areaInfr" | "heatingType" | "gardenSize" | "similarApts";

export type IApplicationAdditionalQuestionTypes = IApplicationAdditionalFlatQuestionTypes | IApplicationAdditionalHouseQuestionTypes;

const ApplicationFormContext = createContext<IContextValue | null>(null);

export const ApplicationFormContextProvider = (props: IApplicationFormProviderProps) => {
    const {children, getAnalyticsData, ...contextValues} = props;

    const isMobile = useIsMobile();
    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const applicationData = useAppSelector((state) => state.application[contextValues.storeHash]);
    const storedQuestions = useAppSelector((state) => state.sentLead.storedValues?.questions);
    const isAuthenticated = useIsAuthenticated();

    const selectedQuestions = contextValues.applicationMessageLogic.currentState.selectedQuestions;

    useEffect(() => {
        dispatch<ISentLeadActions>(setSentLeadValuesAction({questions: selectedQuestions}));
    }, [selectedQuestions]);

    useEffect(() => {
        // initialize additional questions
        const isPropertyWithPrice = applicationData?.property?.detail?.price || applicationData?.property?.detail?.price_m2;
        let selectedQuestions: IApplicationAdditionalQuestionTypes[] = storedQuestions || [];
        if (isPropertyWithPrice) {
            selectedQuestions = selectedQuestions.filter((question) => question !== "price");
        }
        if (!isPropertyWithPrice && !selectedQuestions.includes("price")) {
            selectedQuestions.unshift("price");
        }

        contextValues.applicationMessageLogic.helpers.setSelectedQuestions(selectedQuestions);
    }, [storedQuestions]);

    const property = applicationData?.property?.detail || null;
    const offer = applicationData?.offer?.detail || null;
    const vendor = applicationData?.vendor?.detail || null;
    const offerId = contextValues.offerId;

    return (
        <>
            <ApplicationFormContext.Provider
                value={{
                    ...contextValues,
                    property: property,
                    offer: offer,
                    offerId,
                    vendor: vendor,
                    isMobile,
                    analyticsData: getAnalyticsData(),
                    customFormText: props.customFormText,
                    isAuthenticated
                }}
            >
                {children}
            </ApplicationFormContext.Provider>
        </>
    );
};

export const useApplicationFormContext = () => {
    const context = useContext(ApplicationFormContext);

    if (!context) {
        throw new Error("No ApplicationFormContext found when calling useApplicationFormContext.");
    }

    return context;
};
import {createContext, PropsWithChildren, useContext, useEffect} from "react";
import {useDispatch} from "react-redux";
import type {Dispatch} from "redux";

import {useIsMobile} from "@pg-mono/hooks";

import {ISentLeadActions, setSentLeadValuesAction} from "../../../lead/reducers/sent_lead_reducer";
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {useAppSelector} from "../../../store/hooks";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {IVendorDetailApplication} from "../../../vendor/types/IVendorDetailApplication";
import {IApplicationAnalyticsData} from "../../tracking/tracking";
import {ApplicationVariant} from "../../types/ApplicationVariant";
import {MessageType} from "../../types/MessageType";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/ApplicationSource";

interface IContextValue {
    // tracking
    analyticsData: IApplicationAnalyticsData;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    // form field visibility
    alwaysShowFields?: boolean;
    hideMessageAndQuestionsSection?: boolean;
    hideQuestions?: boolean;
    hideRooms?: boolean;
    // TODO: Remove this field from this context
    hideRodo?: boolean;
    hideSubmitButton?: boolean;

    // data
    property: IPropertyDetailApplication | null;
    offer: IOfferDetailApplication | null;
    offerId?: number;
    vendor: IVendorDetailApplication | null;

    // rest
    applicationMessageLogic: IApplicationMessageLogic;
    isAuthenticated?: boolean;
    isMobile: boolean;
    formPreviouslySent: boolean;
    onFormControlClick?: () => void;
    storeHash: string;
    onCloseModal: (forceClose?: boolean) => void;
    formDataInitialized?: boolean;
    isRequiredUserDataFilled?: boolean;
    emailNotificationProps: {
        isActive: boolean;
        onClose: () => void;
    };
    applicationVariant?: ApplicationVariant;

    //  post
    leadIsSubmitting: boolean;
    customFormText?: string;
    creditData?: {contribution: number; period: number};
}

type IApplicationFormProviderProps = PropsWithChildren<
    Omit<IContextValue, "property" | "offer" | "vendor" | "viewType" | "analyticsData" | "isMobile"> & {
        getAnalyticsData: () => IApplicationAnalyticsData;
    }
>;

export interface IApplicationMessageLogic {
    currentState: {
        messageType: MessageType;
        selectedQuestions: IApplicationAdditionalQuestionTypes[];
    };
    helpers: {
        setMessageType: (messageType: MessageType) => void;
        setSelectedQuestions: (questionsIds: IApplicationAdditionalQuestionTypes[]) => void;
    };
}

export type IApplicationAdditionalFlatQuestionTypes = "price" | "parkAndStorage" | "rent" | "payPlan" | "areaInfr" | "similarApts";

export type IApplicationAdditionalHouseQuestionTypes = "price" | "payPlan" | "areaInfr" | "heatingType" | "gardenSize" | "similarApts";

export type IApplicationAdditionalQuestionTypes = IApplicationAdditionalFlatQuestionTypes | IApplicationAdditionalHouseQuestionTypes;

const ApplicationFormContext = createContext<IContextValue | null>(null);

export const ApplicationFormContextProvider = (props: IApplicationFormProviderProps) => {
    const {children, getAnalyticsData, ...contextValues} = props;

    const isMobile = useIsMobile();
    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const applicationData = useAppSelector((state) => state.application[contextValues.storeHash]);
    const storedQuestions = useAppSelector((state) => state.sentLead.storedValues?.questions);
    const isAuthenticated = useIsAuthenticated();

    const selectedQuestions = contextValues.applicationMessageLogic.currentState.selectedQuestions;

    useEffect(() => {
        dispatch<ISentLeadActions>(setSentLeadValuesAction({questions: selectedQuestions}));
    }, [selectedQuestions]);

    useEffect(() => {
        // initialize additional questions
        const isPropertyWithPrice = applicationData?.property?.detail?.price || applicationData?.property?.detail?.price_m2;
        let selectedQuestions: IApplicationAdditionalQuestionTypes[] = storedQuestions || [];
        if (isPropertyWithPrice) {
            selectedQuestions = selectedQuestions.filter((question) => question !== "price");
        }
        if (!isPropertyWithPrice && !selectedQuestions.includes("price")) {
            selectedQuestions.unshift("price");
        }

        contextValues.applicationMessageLogic.helpers.setSelectedQuestions(selectedQuestions);
    }, [storedQuestions]);

    const property = applicationData?.property?.detail || null;
    const offer = applicationData?.offer?.detail || null;
    const vendor = applicationData?.vendor?.detail || null;
    const offerId = contextValues.offerId;

    return (
        <>
            <ApplicationFormContext.Provider
                value={{
                    ...contextValues,
                    property: property,
                    offer: offer,
                    offerId,
                    vendor: vendor,
                    isMobile,
                    analyticsData: getAnalyticsData(),
                    customFormText: props.customFormText,
                    isAuthenticated
                }}
            >
                {children}
            </ApplicationFormContext.Provider>
        </>
    );
};

export const useApplicationFormContext = () => {
    const context = useContext(ApplicationFormContext);

    if (!context) {
        throw new Error("No ApplicationFormContext found when calling useApplicationFormContext.");
    }

    return context;
};
